module.exports = __webpack_public_path__ + "static/img/8.60bf6249.png";